<app-loader [isLoading]="isLoading"></app-loader>
@if(!isMobileView){
<div class="manage-user-section">
  <div class="manage-user-header">
    <h1 class="manage-user-text">DP 1.0</h1>
  </div>

  <div style="display: flex; flex-direction: row; gap: 12px">
    <input
      type="text"
      class="dp-input-control searchInput"
      placeholder="Search in displayed result"
      (input)="onInputChange($event)"
    />
    <button class="filter-button" (click)="onClickFilter()">
      <h1 class="filter-button-text">Filter</h1>
      <img src="assets/filter.svg" />
    </button>
  </div>
  <!-- data table  -->
  @if(isLoader){ @if(isLoader){
  <table class="dp-table">
    <thead class="dp-table-header">
      <tr>
        <th>Address</th>
        <th></th>
      </tr>
    </thead>
    <tbody class="dp-table-body">
      <tr *ngFor="let i of [].constructor(numberOfLoaders)">
        <td *ngFor="let j of [].constructor(9)">
          <dp-loader></dp-loader>
        </td>
      </tr>
    </tbody>
  </table>
  } } @else {
  <div class="dp-table-scroll" #tableScroll>
    <dp-table
      [dataTable]="filterDataTable"
      [displayedColumns]="displayColumnData"
      [componentMap]="cellComponentMap"
      (cellClick)="openDialog($event)"
      [isLoader]="isLoader"
    ></dp-table>
    <button class="dp-primary-btn" style="height: 40px;" (click)="fetchUsers()">Load More</button>
  </div>
  }
</div>
} @else {
<div class="manage-user-section">
  <div class="manage-user-button-group"></div>

  <button class="filter-button" (click)="onClickFilter()">
      <h1 class="filter-button-text">Filter</h1>
      <img src="assets/filter.svg" />
    </button>

  <div class="dataList">
    <div class="scroll-container" #tableScroll>
      @if(filterDataTable.length !== 0){ @for( lists of filterDataTable; track lists){
      <ul class="eachdataList">
        <li class="data">
          <span>{{ lists.address ? lists.address : "-" }}</span>

          <div
            class="d-flex align-items-center btn-gap justify-content-between"
          >
            <button
              class="manage-user-btn dp-secondary-btn view-btn"
              (click)="openDialogMobile(lists)"
            >
              Assign
            </button>
          </div>
          <!-- <wislist-action (cellClick)="onCellClick($event)"></wislist-action> -->
        </li>
      </ul>

      }
    <button class="dp-primary-btn" style="height: 40px;" (click)="fetchUsers()">Load More</button>
    } @else{
      <div class="d-flex justify-content-center align-items-center mt-10">
        No records found
      </div>
      }
    </div>
    <!-- } -->
  </div>
</div>
}
